'use client';
import { isBrowser } from '@s7/platform';
import { noop } from '@s7/utils';

var browserAction = function(fn) {
    return isBrowser() ? fn : noop;
};

export { browserAction };
